module.exports = __webpack_public_path__ + "img/logo-color.4a832849.svg";